const ContactInfo = {
    phone : '+91 8805929292',
    email: 'enquiry@wolfinvestment.in',
}

export default ContactInfo